import React, { useEffect } from "react";
import styles from "./Viewer.module.scss";

const Viewer = ({ product }) => {
    
    useEffect(() => {
        window.CI360.init()
      }, [product])

    const { ViewerPath } = product;
    console.log(`${process.env.PUBLIC_URL}/product-images/${ViewerPath}/`)

    return (
        <div className={styles.viewerColumn}>
            <div
                className="cloudimage-360"
                data-folder={`${process.env.PUBLIC_URL}/product-images/${ViewerPath}/`}
                data-filename="{index}.png"
                data-amount="24"
                data-pointer-zoom="1.5"
                >
            </div>
        </div>
    )
}

export { Viewer };